<template>
  <div class="mb-1">
    <div class="row no-gutters d-flex flex-row align-items-center workoutplan-panel-overview bg-light px-2" style="border:1px solid rgba(0, 0, 0, 0.125);border-bottom:none;">
      <div class="mr-auto">
        <h5 class="text-center m-2">
          <span :class="{'text-muted':!week.name}">{{ weekName }}</span>
          <!-- <span v-if="week.name">{{ week.name }}</span>
          <span v-else class="text-muted">Week {{ week.position }}</span> -->
          <a href="#" @click.prevent="startEditWeekDetails"><i class="mdi mdi-18px mdi-pencil"></i></a>
        </h5>
      </div>
      <div class="">
        <a href="#" class="btn btn-link p-0 m-0"><i class="mdi mdi-18px mdi-cursor-move sort-week-handle"></i></a>
        <a href="#" class="btn btn-link p-0 m-0" @click.prevent="duplicateWeek"><i class="mdi mdi-18px mdi-content-copy"></i></a>
        <vueConfirmationButton
          :messages="['', 'Are you sure?', 'Deleting!']"
          icon_css="mdi mdi-18px mdi-delete"
          css="btn btn-link p-0 m-0"
          v-on:confirmation-success="deleteWeek()"
        />
          <!-- <div class="btn-group">
            <a
              aria-expanded="false"
              aria-haspopup="true"
              data-toggle="dropdown"
              href="#"
            ><i class="mdi mdi-18px mdi-dots-vertical"></i></a>
            <div class="dropdown-menu dropdown-menu-right">
              <button class="dropdown-item" type="button">Delete Week</button>
            </div>
          </div> -->
      </div>
    </div>
    <div class="row no-gutters d-flex workoutplan-panel-overview">
      <!-- <div class="col-1" style="border-top:1px solid rgba(0, 0, 0, 0.125)">
        <p class="text-center my-2" v-if="week.name">{{ week.name }}</p>
        <p class="text-center my-2 text-muted" v-else>Week {{ week.position }}</p>
        <div class="d-flex justify-content-around">
          <a href="#" @click.prevent="startEditWeekDetails"><i class="mdi mdi-18px mdi-pencil"></i></a>
          <a href="#"><i class="mdi mdi-18px mdi-cursor-move sort-week-handle"></i></a>
          <a href="#" @click.prevent="duplicateWeek"><i class="mdi mdi-18px mdi-content-copy"></i></a>
          <vueConfirmationButton
            :messages="['', 'Are you sure?', 'Deleting!']"
            icon_css="mdi mdi-18px mdi-delete"
            css="btn btn-link p-0 m-0"
            v-on:confirmation-success="deleteWeek()"
          />
        </div>
      </div>       -->
        <!-- group="{ name: 'days', pull: 'clone', put: true }" -->
        <!-- handle=".move-handle" -->
        <!-- is="draggable" -->
        <!-- :list="dayList" -->
        <!-- v-model="week.days" -->
        <!-- :value="dayList" -->
      <div class="col">
        <!-- draggable off for now by hiding the handle -->
        <draggable
          group="days"
          v-model="dayList"
          @end="dayDragged"
          class="row no-gutters"
          handle="move-handle"
          >
          <div
            v-for="(day_idx) in 7"
            v-bind:key="week.id+'_'+day_idx"
            class="col align-items-stretch"
            >

          <!-- <div class="col align-items-stretch" v-for="(day_idx) in 7" v-bind:key="day_idx"> -->
            <!-- <h5 v-if="week.position==1" class="text-center">{{ day_idx }}</h5> -->
            <!-- <h5 class="text-center">{{ ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'][day_idx-1] }}</h5> -->
            <div class="card h-100">
              <div class="card-header" :class="{'text-muted':!getDayByPosition(day_idx)}">
                <!-- <span class="text-muted"><small>Day {{ (week.position-1)*7+ day_idx }}</small></span><br> -->
                <div v-if="getDayByPosition(day_idx)" style="font-weight:600">{{getDayByPosition(day_idx).name}}</div>
                <div v-else>Rest</div>
                <span class="small text-muted" style="position: absolute; top:0; right:0; padding: 3px 3px 0 0">
                  <!-- {{ ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'][day_idx-1] }} -->
                  {{ day_idx + ((week.position-1)*7) }}
                </span>
              </div>
              <div class="card-body small p-2">
                <div v-if="getDayByPosition(day_idx)">
                  <div
                    class="my-1"
                    v-for="group in getDayByPosition(day_idx).groups"
                    v-bind:key="group.id"
                  >
                    <strong>{{ group.name }}</strong>
                    <div
                      v-for="exercise in group.exercises"
                      v-bind:key="exercise.pivot.id"
                    >{{exercise.name }} {{exercise.pivot.sets}}x{{exercise.pivot.reps}}
                    <template v-if="exercise.pivot.rep_unit!='x'">{{exercise.pivot.rep_unit}}</template>
                    </div>
                  </div>
                </div>
              </div>
              <div class="card-footer mt-auto">
                <template v-if="!getDayByPosition(day_idx)">
                  <a href="#" @click.prevent="startAddDay(day_idx)"><i class="mdi mdi-18px mdi-plus"></i></a>
                </template>
                <template v-else>
                  <a href="#" @click.prevent="startEditDay(day_idx)"><i class="mdi mdi-18px mdi-pencil"></i></a>
                  <!-- <a href="#"><i class="mdi mdi-18px mdi-cursor-move move-handle"></i></a> -->
                  <!-- <a href="#"><i class="mdi mdi-18px mdi-content-copy"></i></a> -->
                  <!-- <a href="#"><i class="mdi mdi-18px mdi-dots-vertical"></i></a> -->
                  <!-- <div class="btn-group">
                    <a
                      aria-expanded="false"
                      aria-haspopup="true"
                      data-toggle="dropdown"
                      href="#"
                    ><i class="mdi mdi-18px mdi-dots-vertical"></i></a>
                    <div class="dropdown-menu dropdown-menu-right">
                      <button class="dropdown-item" type="button">Delete Day</button>
                    </div>
                  </div> -->
                  <!-- <div class="form-check form-check-inline mr-0">
                    <input type="checkbox" class="form-check-input" v-model="selectedDays" :value="day_idx">
                  </div> -->
                </template>
              </div>
            </div>
          </div>
        </draggable>
      </div>
    </div>

    <!-- <div class="container-fluid horizontal-scrollable">
      <div class="row flex-row flex-nowrap">
        <div class="col-4 my-3" v-bind:key="day.id" v-for="day in selectedDaysToDisplay">
          <WorkoutPlanPanelDay :initial-day="day" @day-updated="dayUpdated" />
        </div>
      </div>
    </div> -->

    <form-modal v-if="showAddDayModal" @close="showAddDayModal=false" @submitted="addDay">
      <h3 slot="header">Add day to Week {{week.position}}</h3>
      <div slot="body">
        <div class="form-row align-items-center mb-2">
          <div class="col-3">
            <label for="day-to-add-name">Name</label>
          </div>
          <div class="col">
            <input
              class="form-control"
              placeholder="e.g. Day 3 or Upper Body"
              id="day-to-add-name"
              required
              v-model="dayToAddDetails.name"
            />
          </div>
        </div>
        <div class="form-row align-items-center mb-2">
          <div class="col-3">
            <label for="day-to-add-description">Description</label>
          </div>
          <div class="col">
            <textarea
              class="form-control"
              placeholder="Add any notes here"
              id="day-to-add-description"
              v-model="dayToAddDetails.description"
            />
          </div>
        </div>
      </div>
      <div slot="footer">
        <button class="btn btn-default" @click="showAddDayModal = false" type="reset">Cancel</button>
        <button type="submit" class="btn btn-primary">Add Day</button>
      </div>
    </form-modal>

    <modal v-if="showEditDayModal" @close="showEditDayModal=false">
      <template v-if="dayToEdit">
        <h3 slot="header">Edit Week {{week.position}}: {{ dayToEdit.name }}</h3>
        <div slot="body">
          <WorkoutPlanPanelDay :initial-day="dayToEdit" @day-updated="dayUpdated" />
          <!-- <div class="form-row align-items-center mb-2">
          </div> -->
        </div>
        <template slot="footer">
          <vueConfirmationButton
            :messages="['Delete', 'Are you sure?', 'Deleting!']"
            icon_css="mdi mdi-delete"
            css="btn btn-danger mr-auto"
            v-on:confirmation-success="deleteDay()"
          />
          <button class="btn btn-default" @click="showEditDayModal = false">Done</button>
          <!-- <button class="btn btn-primary" @click="updateDay">Save</button> -->
        </template>
      </template>
    </modal>

    <form-modal v-if="showEditWeekDetailsModal" @close="showEditWeekDetailsModal=false" @submitted="updateWeek">
      <h3 slot="header">Edit workout plan week</h3>
      <div slot="body">
        <div class="form-row align-items-center mb-2">
          <div class="col-3">
            <label for="week-to-add-name">Name</label>
          </div>
          <div class="col">
            <input
              class="form-control"
              placeholder="Leave blank for default"
              id="week-to-add-name"
              v-model="updatedWeekDetails.name"
            />
          </div>
        </div>
      </div>
      <div slot="footer">
        <button type="reset" class="btn btn-default" @click="showEditWeekDetailsModal = false">Cancel</button>
        <button type="submit" class="btn btn-primary">Update Week</button>
      </div>
    </form-modal>
  </div>
</template>
<script>
import WorkoutPlanPanelDay from "@coach/js/components/WorkoutPlanPanelDay.vue";
import vueConfirmationButton from '@coach/js/components/vue-confirmation-button';
import { each } from "lodash";

export default {
  props: ["initialWeek"],
  components: {
    WorkoutPlanPanelDay,
    vueConfirmationButton
  },
  data() {
    return {
      week: this.initialWeek,
      showAddDayModal: false,
      showEditDayModal: false,
      showEditWeekDetailsModal: false,
      updatedWeekDetails: {
        name: this.initialWeek.name,
      },
      dayToAddDetails: {
        name: null,
        description: null,
        position: null
      },
      dayToEditPosition: null,
      selectedDays: [],
      dayList: []
    };
  },
  mounted() {
    for (let index = 1; index < 7; index++) {
      // const element = array[index];
      this.dayList.push(this.getDayByPosition(index));
    }
  },
  computed: {
    selectedDaysToDisplay: function() {
      let days = [];
      this.selectedDays.sort().forEach(position => {
        days.push(this.getDayByPosition(position));
      });
      return days; //this.days.filter((day) => _.indexOf(this.selectedDays,day.position)!= -1);
    },
    dayToEdit: function() {
      return this.getDayByPosition(this.dayToEditPosition);
    },
    dayColumnClass: function() {
      let days = this.week.days.length;
      if (days > 4) {
        days = 4;
      }
      var width = 12 / days;
      return "col-lg-" + width;
    },
    weekName: function() {
      return this.week.name ?? `Week ${this.week.position}`;
    }
  },
  methods: {
    dayDragged: function(event) {
      console.log("Event!!!");
      console.log(event);
    },
    getDayByPosition: function(position) {
      return this.week.days ? this.week.days.find(day => day.position == position) : null;
    },
    // hasDayWithIndex: function(index) {
    //   return !_.isNull(this.week.days[index]);
    // },
    dayUpdated: function(day) {
      this.$emit("week-updated");
    },
    startEditWeekDetails: function() {
      console.log("Editing week");
      this.showEditWeekDetailsModal = true;
    },
    startEditDay: function(position) {
      console.log("Edit day in postion:" + position);
      this.dayToEditPosition = position;
      this.showEditDayModal = true;
    },
    updateWeek: function() {
      var _this = this;
      axios
        .put("/api/workout_plan_weeks/"+this.week.id, {
          name: this.updatedWeekDetails.name,
        })
        .then(response => {
          // _this.workoutPlan.weeks.push(response.data.data)
          _this.$emit("week-updated");
          _this.showEditWeekDetailsModal = false;
        });
    },
    startAddDay: function(position) {
      console.log("Add a day in postion:" + position);
      this.dayToAddDetails.position = position,
      this.showAddDayModal = true;
      this.$nextTick(
        function() {
          document.getElementById("day-to-add-name").focus();
          // this.$refs.exercise_filter_input.focus();
        }.bind(this)
      );
    },
    addDay: function() {
      var _this = this;
      axios
        .post("/api/workout_plan_days", {
          workout_plan_week_id: this.week.id,
          name: this.dayToAddDetails.name,
          description: this.dayToAddDetails.description,
          position: this.dayToAddDetails.position
        })
        .then(response => {
          _this.showAddDayModal = false;
          _this.dayToAddDetails = {
            name: null,
            description: null,
            position: null
          };
          // _this.week.days.push(response.data.data);
          _this.dayUpdated();
          // Open edit modal
          _this.startEditDay(response.data.data.position);
        }).catch(error => {
          console.log(error);
        });
    },
    deleteDay: function() {
      var _this = this;
      axios
        .delete("/api/workout_plan_days/" + _this.dayToEdit.id)
        .then(response => {
          _this.showEditDayModal = false;
          _this.dayUpdated();
        });
    },
    deleteWeek: function() {
      var _this = this;
      axios
        .delete("/api/workout_plan_weeks/" + this.week.id)
        .then(response => {
          _this.dayUpdated();
          // _this.dayToAddDetails = {
          //   name: null,
          //   description: null
          // };
          // Object.assign(_this.day, response.data.data);
          // _this.$destroy();
          // delete(_this.week);
          _this.showAddDayModal = false;
        });
    },
    duplicateWeek: function() {
      var _this = this;
      axios
        .post("/api/workout_plan_weeks/" + this.week.id + "/duplicate", {})
        .then(response => {
          _this.$toasted.success(this.weekName + " duplicated!");
          _this.dayUpdated();
          // Object.assign(_this.day, response.data.data);
          // _this.week.days.push(response.data.data);
          _this.showAddDayModal = false;
        });
    }
  },
  watch: {
    initialWeek: function(newVal, oldVal) {
      Vue.set(this, "week", newVal);
    },
    selectedDays: function(newVal, oldVal) {
      if(newVal!=oldVal) {
        console.log("Week days selected")
        this.$emit("days-selected", this.selectedDaysToDisplay);
      }
    }
  }
};
</script>
<style scoped>
/* The heart of the matter */
.horizontal-scrollable > .row {
  overflow-x: auto;
  white-space: nowrap;
}
.horizontal-scrollable > .row > .col-xs-4 {
  display: inline-block;
  float: none;
}

.card {
  border-radius: 0;
}
.card-header {
  padding: 0.5rem 0.5rem;
  border-radius: 0;
}
.card-footer {
  padding: 0.5rem 0.5rem;
  border-radius: 0;
  border-top: none;
  background-color: #fff;
}
</style>
